<template>
  <div class="wh-container">
    <home-nav-bar>
      <div slot="right" class="nav-bar-right">
        <template v-if="searching">
          <van-button size="small" type="primary" @click="handleSearch">
            <van-icon name="search" size="18" color="#ffffff" class="icon" />
          </van-button>
        </template>
        <template v-else>
          <van-icon name="plus" class="icon" @click="addPlot" />
          <van-icon name="search" class="icon" @click="showSearch" />
        </template>
      </div>
      <div slot="title">
        <van-field
          v-if="searching"
          v-model="searchKeyword"
          center
          clearable
          placeholder="请输入搜索关键字"
        />
        <template v-else>
          <div v-if="extraParams.landName">
            {{ extraParams.landName }} <van-icon name="close" @click="clearSearch" />
          </div>
          <template v-else>
            我的地块
          </template>
        </template>
      </div>
    </home-nav-bar>
    <router-link :to="{name:'MapMode'}" class="map-mode-btn" block type="info">
      <div class="left" />
      <div class="right">
        <span class="text">进入地图模式</span>
        <van-icon class="icon" name="location-o" />
      </div>
    </router-link>
    <wh-mobile-list
      ref="landList"
      class="land-list"
      :extra-params="extraParams"
      data-src="/api/getFarmlandList"
      height="100%"
    >
      <template v-slot="{list}">
        <router-link
          v-for="(item,key) in list"
          :key="key"
          tag="div"
          :to="{name: 'PlotDetail', query: {landId: item.id, landName: item.landName}}"
          class="land-item"
        >
          <van-swipe-cell>
            <van-row type="flex" justify="space-between">
              <van-col span="8">
                <crop-cover-image class="cover-image-box" :crop-list="item.cropList" />
              </van-col>
              <van-col class="right-content" span="16">
                <div class="land-name">
                  {{ item.landName }}
                </div>
                <van-tag round class="tag" color="#f7f7f7" text-color="#404040">
                  {{ item.cropList.length ? '使用中': '闲置中' }}
                </van-tag>
              </van-col>
            </van-row>
            <template #right>
              <van-button text="删除" type="danger" style="height:100%;pading:0 12px" @click="deletePlot(item.id)" />
            </template>
          </van-swipe-cell>
        </router-link>
      </template>
    </wh-mobile-list>
    <plot-popup :visible.sync="popup.plot.visible" @submitFormSuccess="refreshLandList" />
  </div>
</template>

<script>
import api from '@/api'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import CropCoverImage from '@/views/productManage/MyPlot/CropCoverImage'
import PlotPopup from '@/views/productManage/components/PlotPopup'
export default {
  name: 'MyPlot',
  components: { PlotPopup, CropCoverImage, HomeNavBar, WhMobileList },
  data() {
    return {
      extraParams: {
        companyId: this.$store.getters.companyId,
        fuzzy: undefined,
        // landType: undefined,
        landName: undefined
      },
      searching: false,
      searchKeyword: '',
      popup: {
        plot: {
          visible: false
        }
      }
    }
  },
  methods: {
    showSearch() {
      this.searching = true
    },
    clearSearch() {
      this.searchKeyword = ''
      this.extraParams.landName = undefined
      this.extraParams.fuzzy = undefined
      this.searching = false
    },
    handleSearch() {
      this.extraParams.fuzzy = true
      this.extraParams.landName = this.searchKeyword
      this.searching = false
    },
    addPlot() {
      this.popup.plot.visible = true
    },
    refreshLandList(flag) {
      if (flag) {
        this.$refs.landList.onRefresh()
      }
    },
    deletePlot(id) {
      this.$dialog.confirm({
        title: '是否删除?'
      })
        .then(() => {
          api.deleteFarmland({ ids: [id] }).then(res => {
            this.$toast('地块删除成功')
            this.refreshLandList(true)
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style lang='less' scoped>
.wh-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.nav-bar-right {
  .icon + .icon {
    margin-left: 10px;
    font-weight: bold;
  }
}
.map-mode-btn {
  text-align: right;
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;
  color: #fff;
  background-color: #fff;
  font-size: 14px;
  .right {
  color: @primary-color;
    .icon {
      margin-left: 10px;
    }
  }
}
/deep/ .land-list {
  padding: 10px 20px;
  background: #f3f7f8;
  .land-item {
    padding: 12px 20px;
    border-radius: 12px;
    background: #ffffff;
    margin-bottom: 30px;
    min-height: 80px;
    .right-content {
      margin-top: 10px;
      .land-name {
        font-size: 14px;
        font-weight: 600;
      }
      .tag {
        margin-top: 6px;
        font-size: 12px;
        padding: 0.2em 0.5em;
      }
    }
  }
}
.cover-image-box  {
  width: 64px;
  height: 64px;
}
</style>
